import React from 'react'
import { Link } from 'react-router-dom'
export const Palermo = () => {
    return (
        <main className='margen1  bg-[#EEF2FF] dark:bg-[#050817]'>
            <section className='mb-3'>
                <h1 className='titulo1 text-center mb-[3rem] '>Premium Web Design Agency in Exton, PA</h1>
                <p className=' !font-medium !leading-5'>
                    At Power Bit, we blend elite creativity, targeted strategy, and robust technology to engineer websites that truly resonate with your audience. Operating from Exton, we partner with ambitious brands looking to dominate the digital landscape.
                </p>
            </section>

            <section className='mb-3'>
                <h2 className='lg:text-3xl text-xl font-bold mb-3'>What We Do</h2>
                <ul className='!font-medium !leading-5'>
                    <li>Modern, high-performance <strong>web design</strong> tailored for sophisticated business models.</li>
                    <li>Data-driven <strong>digital advertising,</strong> precision audience segmentation, and premium asset creation.</li>
                    <li><strong>Strategic growth marketing </strong> to position your brand and attract high-net-worth clients.</li>
                </ul>
            </section>

            <section className='mb-3'>
                <h2 className='lg:text-3xl text-xl font-bold mb-3'>Web Design Crafted in Exton, Pennsylvania</h2>
                <p className='!font-medium !leading-5'>
                    We are a premier team based in Exton, deeply passionate about digital communication and high-end design. We understand the rhythm of both local enterprises and regional markets, delivering solutions that meet the highest standards. If you are looking for an agile, professional agency that delivers measurable ROI, you are in the right place.
                </p>
            </section>

            <section className='mb-3'>
                <h2 className='lg:text-3xl text-xl font-bold mb-3'>Ready to Elevate Your Online Authority?</h2>
                <p className='!font-medium !leading-5 mb-5'>
                    Connect with us and share your vision. At Power Bit, we turn high-level concepts into seamless digital experiences that yield results.
                </p>
                <a href="/#contacto" className="underline font-semibold underline underline-offset-4 dark:font-medium decoration-[#274dd8]  dark:hover:decoration-[#fff] hover:decoration-[#000] text-white-600">Solicitá tu propuesta</a>
            </section>
        </main>
    )
}